<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" v-bind="$attrs">
        New customer
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title">
        Create customer
      </v-card-title>

      <v-card-text>
        <v-divider class="pb-6"></v-divider>

        <customer-create-edit-form ref="createEditForm" v-if="dialog">
          <template #buttons-after>
            <v-btn depressed color="error" class="ml-2" @click="dialog = false"
              >Cancel</v-btn
            >
          </template>
        </customer-create-edit-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomerCreateEditForm from './CustomerCreateEditForm'

export default {
  name: 'CustomerCreateModal',
  components: {
    CustomerCreateEditForm
  },
  data: () => ({
    dialog: false
  })
}
</script>
